import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '@/store';

const service = axios.create({ baseURL: process.env.NODE_ENV === 'development' ? 'zky/api' : 'api', timeout: 600000 });

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('ipp_token');
    if (token) config.headers['X-Token'] = token;
    const lang = localStorage.getItem('ipp_lang');
    if (lang) config.headers['x-lang'] = lang;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 1000) {
      return response.data;
    } else if (res.code === 1010) {
      // Message.error('登录失效，请重新登录');
      store.dispatch('FedLogOut');
      return Promise.reject(new Error('Error Token,Please login again.'));
    } else {
      return Promise.reject(new Error(res.data));
    }
  },
  error => {
    return Promise.reject(new Error('Bad network,please retry!'));
  }
);

export default service;
